module.exports = __webpack_public_path__ + "img/男-甲状腺癌h.7b2181b9.png";